import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, Icon } from '@mui/material'
import React from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'

const JobBoardMobileAccordion = ({ index, item, isMobile, handleViewJob }) => {
  return (
    <>
      <Accordion
        sx={{ boxShadow: 'none', width: '100%' }}
        disableGutters
        key={index}
        defaultExpanded={index === 0}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginRight: '8px',
              gap: '16px',
            }}
          >
            <Typography
              fontFamily={'Oswald'}
              fontWeight={600}
              variant="h2"
            >{`${item.job_background_name}`}</Typography>
            <Box sx={{ backgroundColor: 'alternate.light', borderRadius: '3.5px' }}>
              <Typography noWrap sx={{ color: 'alternate.main', padding: '8px 16px' }}>
                {`${item.advertisements?.length} ${
                  item.advertisements?.length > 1 ? 'jobs' : 'job'
                } available`}
              </Typography>
            </Box>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: '24px',
            }}
          >
            {item?.advertisements?.map((job, index) => {
              const date = new Date(job?.publish_at)
              const publishedDate = date?.toISOString().split('T')[0]

              return (
                <Box
                  key={index}
                  sx={{
                    padding: '24px 32px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: 1,
                    borderRadius: '4.5px',
                    borderColor: 'gray-line.main',
                    width: '100%',
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <Typography variant="subtitle2" sx={{ color: '#B8B8B8', marginBottom: '4px' }}>
                      {`Posted on ${publishedDate}`}
                    </Typography>
                    <Typography fontFamily={'Oswald'} fontWeight={600} variant="h2">
                      {job.position_title}
                    </Typography>
                    {!isMobile && (
                      <Typography variant="h4">{`${job.job_level_name} • RM ${job.min_salary} - RM ${job.max_salary}`}</Typography>
                    )}
                    {isMobile && (
                      <>
                        <Typography variant="h4">{`${job.job_level_name}`}</Typography>
                        <Typography>{`RM ${job.min_salary} - RM ${job.max_salary}`}</Typography>
                      </>
                    )}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginTop: '16px',
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: 'gray-background.main',
                          borderRadius: '3.5px',
                          border: 1,
                          borderColor: 'gray-line.main',
                          padding: '8px 16px',
                        }}
                      >
                        <Typography variant="subtitle2">
                          {job.position_type === 'full-time'
                            ? 'Full time'
                            : job.position_type === 'part-time'
                            ? 'Part time'
                            : 'Contract'}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          backgroundColor: 'gray-background.main',
                          borderRadius: '3.5px',
                          border: 1,
                          borderColor: 'gray-line.main',
                          padding: '8px 16px',
                        }}
                      >
                        <PlaceOutlinedIcon sx={{ fontSize: '16px' }} />
                        <Typography variant="subtitle2">{job.city}</Typography>
                      </Box>
                    </Box>
                    {isMobile && (
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'end',
                          marginTop: '32px',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            cursor: 'pointer',
                          }}
                        >
                          <Typography
                            variant="h4"
                            sx={{ color: 'alternate.main' }}
                            onClick={() => handleViewJob(job.id)}
                          >
                            View job
                          </Typography>
                          <Icon sx={{ color: 'alternate.main' }}>chevron_right</Icon>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
              )
            })}
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default JobBoardMobileAccordion
